import React from "react";

type PageLayoutProps = {
    header?: React.ReactNode;
    footer?: React.ReactNode;
    children: React.ReactNode;
    pageClassName?: string;
    headerClassName?: string;
    headerInnerClassName?: string;
    contentClassName?: string;
    footerClassName?: string;
};

const PageLayout = ({
    header,
    footer,
    children,
    pageClassName,
    headerClassName,
    headerInnerClassName,
    contentClassName,
    footerClassName,
}: PageLayoutProps) => {
    return (
        <div className={pageClassName}>
            {header && (
                <div className={headerClassName}>
                    {headerInnerClassName ? (
                        <div className={headerInnerClassName}>{header}</div>
                    ) : (
                        header
                    )}
                </div>
            )}
            <div className={contentClassName}>{children}</div>
            {footer && <div className={footerClassName}>{footer}</div>}
        </div>
    );
};

export default PageLayout;
